import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/account-components/account/account.component.tsx");
